import React from 'react';
import Bell from './icons/Bell';
import Cog from './icons/Cog';
import Dashboard from './icons/Dashboard';
import Dots from './icons/Dots';
import Events from './icons/Events';
import Graphs from './icons/Graphs';
import Journal from './icons/Journal';
import Parameters from './icons/Parameters';
import Prices from './icons/Prices';
import Question from './icons/Question';
import Reports from './icons/Reports';
import Schemas from './icons/Schemas';
import Search from './icons/Search';
import Warehouses from './icons/Warehouses';
import Repairs from "./icons/Repairs";
import Equipments from "./icons/Equipments";
import Flexi from './icons/Flexi';
import MIcon from '../../components/material/Icon';

const ICONS = {
  Bell,
  Cog,
  Dashboard,
  Dots,
  Events,
  Graphs,
  Journal,
  Parameters,
  Prices,
  Question,
  Reports,
  Schemas,
  Search,
  Warehouses,
  Repairs,
  Equipments,
  Flexi,
};

const MATERIAL_ICONS = [
  'help',
  'keyboard_arrow_right',
  'keyboard_arrow_left',
  'close',
  'poll',
  'edit',
  'delete',
  'view_quilt',
  'description',
  'iso',
  'note_add',
  'assignment',
  'style',
  'list',
  'grain',
  'shop_two',
  'settings',
  'person_outline',
  'forward',
  'account_circle',
  'view_module',
  'person',
  'people',
];

const Icon = ({ icon, ...rest }) => {
  if (!ICONS[icon]) {
    if (MATERIAL_ICONS.indexOf(icon) > -1) {
      return <MIcon name={icon} />;
    }

    throw new Error(`No such icon ${icon}`);
  }

  const IconEl = ICONS[icon];

  return <IconEl {...rest} />;
};

export default Icon;
